import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const location = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getLocations () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations`)
  },
  getInitialLocations () {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations`)
  },
  getLocationsGroupedBySite (clientId) {
    const client = clientId? clientId : this.getClientId()
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${client}/sites/locations`)
  },
  getAllLocationsGroupedBySite (clientId) {
    const client = clientId? clientId : this.getClientId()
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${client}/sites/locations/all`)
  },
  getInitialLocationsGroupedBySite () {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/locations`)
  },
  addLocations (location) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${location.siteId}/locations`, location)
  },
  editLocations (location) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${location.siteId}/locations/${location.id}`, location)
  },
  getLocationMap(locationId){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/map/svgWithDeskNames`)
  },
  getLocationDevices(locationId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/devices`)
  },
  saveLocationDevices (locationId, devicesIds, blockAccessUponPriorBooking) {
    const body = { locationId: locationId, devices: devicesIds, blockAccessUponPriorBooking: blockAccessUponPriorBooking }
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/devices`, body)
  },
  activateLocal (locationId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/activate`)
  },
  deactivateLocal (locationId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/deactivate`)
  }
}

export default location
